/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-03 09:12:50
 * @LastEditTime: 2020-09-16 16:22:54
 * @Description: 部门api
 */
import axios from '@/utils/axios'

export const getDepartmentList = (payload) => {
    return axios.get('/department', {
        params: payload
    })
}

export const createDepartment = (data) => {
    return axios.post(`/department`, data)
}

export const updateDepartment = (id, data) => {
    return axios.put(`/department/${id}`, data)
}